import React from 'react';

export const NOT_AVAILABLE = <span style={{ opacity: 0.5 }}>-</span>;
